import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { PrintServices } from "../../../services/printServices";
import { ConfigurationServices } from '../../../configuration/services';
import { TakeawayServices } from '../../services';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the TpvTicketSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-takeaway-order-select-selected',
    templateUrl: 'takeaway-order-select-selected.html',
})
export class TakeawayOrderSelectSelectedPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public takeawayServices: TakeawayServices,
        public globals: Globals,
        private alertCtrl: AlertController,
        public printServices: PrintServices,
        public configurationServices: ConfigurationServices,
        public translate: TranslateService,
        public analyticsServices: AnalyticsServices) {
    }

    styleHeight() {
        //
        let styles;
        //get height screen
        var height = window.innerHeight;
        if ((this.globals.trial_days > 0 && this.globals.trial_days <= 15) || (this.globals.trial_days == 0 && this.globals.restaurant.license === 'free')) {
            height = height - 91;
        } else {
            height = height - 51;
        }
        height = height / 2;
        if (this.globals.platform_mobile) {
            styles = {
                'height': height + 'px',
                'overflow': 'hidden',
                'padding-left': '10px',
                'padding-right': '10px',
            };
        } else {
            styles = {
                'height': height + 'px',
                'overflow': 'hidden',
            };
        }


        return styles;
    }

    openSendOrder() {
        const confirm = this.alertCtrl.create({
            title: this.translate.instant('instant-enviar-comanda'),
            message: this.translate.instant('instant-seguro-quieres-enviar-comanda'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    handler: () => {

                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.sendOrder();
                    }
                }
            ]
        });
        confirm.present();
    }

    async sendOrder() {
        var today = new Date();
        var _order_tmp = [];
        //insert to orders
        _order_tmp = [];

        var _elements_list = [];
        for (let order of this.takeawayServices.order_tmp) {
            var _combo_section = true;
            var _list = [];
            for (let list of this.globals.objectToArray(order.list)) {
                var obj = {};
                if (list.uid_combo_tmp != undefined) {
                    obj = {
                        name: list.name,
                        change: list.change,
                        finish: list.finish,
                        state: list.state,
                        variations: list.variations,
                        uid_combo_tmp: list.uid_combo_tmp,
                        uid_element_combo: list.uid_element_combo,
                        tags: list.tags,
                        uid_element: list.uid_element
                    }

                    if (list.type == 'combo') {
                        _combo_section = false;
                    }
                } else {
                    obj = {
                        name: list.name,
                        change: list.change,
                        finish: list.finish,
                        state: list.state,
                        variations: list.variations,
                        tags: list.tags,
                        uid_element: list.uid_element
                    }
                    _combo_section = false;
                }
                _list.push(obj);
                //guardamos el elemento para insertarlo en la analytics WAITER
                _elements_list.push(list.name);
            }
            var _oder = {
                name: order.name,
                list: _list,
                only_combo: _combo_section,
            }
            _order_tmp.push(_oder);
        }
        //preparamos la extroctura del insert para _data analytics WAITER
        var waiter = {
            'uid': this.globals.restaurant_uid,
            'waiter': this.globals.waiter,
            'elements': _elements_list,
            'date': new Date(),
            'type': "waiter",
            'type_type': "ADD",
        };
        this.analyticsServices.sendWaiter(waiter);

        //getIndexByTableuid
        await this.takeawayServices.getIndexByTableuid();

        //get customer
        var _customer = [];
        if (this.takeawayServices.customer) {
            _customer = this.takeawayServices.customer;
        }

        //sendOrder
        await this.takeawayServices.afs.collection('orders').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'date': today,
            'hour': moment(today).format("HH:mm"),
            'sections': _order_tmp,
            'show_kitchen': true,
            'show_order': true,
            'table': '',
            'table_uid': this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID,
            'type': 'takeaway',
            'waiter': this.globals.waiter,
            'waiter_uid': this.globals.waiter_uid,
            'created_at': new Date(),
            'updated_at': new Date(),
            'provider': 'General',
            'provider_code': '',
            'delivery': this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.delivery,
            'notes': this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].notes,
            'datetime_pickup_delivey': this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].datetime_pickup_delivey,
            'customer': _customer,
        }).then(doc => {
        });

        //getIndexByTableuid
        await this.takeawayServices.getIndexByTableuid();
        //insert to table
        this.takeawayServices.table_tmp = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index];

        _order_tmp = [];

        for (let order of this.takeawayServices.order_tmp) {
            _list = [];

            for (let list of this.globals.objectToArray(order.list)) {

                var last_key = Object.keys(this.takeawayServices.table_tmp.ticket.list)[Object.keys(this.takeawayServices.table_tmp.ticket.list).length - 1]; //get the last key in the object

                if (last_key == undefined) {
                    last_key = '0';//Iniciamos a 0 si esta undefined
                }
                if ((list.type == 'combo' && list.uid_combo_tmp != undefined) || (list.type != 'combo' && list.uid_combo_tmp == undefined)) {
                    if (list.uid_combo_tmp != undefined) {
                        this.takeawayServices.table_tmp.ticket.list[Number(last_key) + 1] = {// es elemento de combo
                            name: list.name,
                            price: list.price,
                            delete: list.delete,
                            count: list.count,
                            type: list.type,
                            uid_element: list.uid_element,
                            variation: list.variations,
                            waiter: this.globals.waiter,
                            waiter_uid: this.globals.waiter_uid,
                            uid_combo_tmp: list.uid_combo_tmp,
                            uid_element_combo: list.uid_element_combo,
                            variation_add: 0,
                            tags: list.tags,
                        };
                    } else {
                        this.takeawayServices.table_tmp.ticket.list[Number(last_key) + 1] = {// articles
                            name: list.name,
                            price: list.price,
                            delete: list.delete,
                            count: list.count,
                            tax: list.tax,
                            type: list.type,
                            uid_element: list.uid_element,
                            variation: list.variations,
                            waiter: this.globals.waiter,
                            waiter_uid: this.globals.waiter_uid,
                            tags: list.tags,
                        };
                    }
                }
            }
        }

        //getIndexByTableuid
        await this.takeawayServices.getIndexByTableuid();
        this.takeawayServices.cleanTicketArray();
        //update tables
        this.takeawayServices.afs.collection('tables').doc(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID).update({
            ticket: this.takeawayServices.table_tmp.ticket,
            state: 'close'
        }).then(async doc => {
            this.takeawayServices.order_tmp = [];
            //getIndexByTableuid
            await this.takeawayServices.getIndexByTableuid();
            //listSelectedTicket
            this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list))

            this.takeawayServices.cleanVariables();
            this.navCtrl.pop();
        });
    }




    one_time: boolean = true;
    async updateInsertTPV(name) {
        //getIndexByTableuid
        await this.takeawayServices.getIndexByTableuid();
        //recuperar mesa
        this.takeawayServices.table_tmp = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index];

        for (let list of this.globals.objectToArray(this.takeawayServices.table_tmp.ticket.list)) {
            if (list.name == name && this.one_time && list.delete == false && list.count == true) {
                list.count = false;
                list.delete = true;
                this.one_time = false;
            }
        }

        var last_key = Object.keys(this.takeawayServices.table_tmp.ticket.list)[Object.keys(this.takeawayServices.table_tmp.ticket.list).length - 1]; //get the last key in the object
        if (last_key == undefined) {
            last_key = '0';//Iniciamos a 0 si esta undefined
        }

        this.takeawayServices.table_tmp.ticket.list[Number(last_key)] = {//Creamos objeto del nuevo plato
            name: this.takeawayServices.order_tmp[0].list[0].name,
            price: this.takeawayServices.order_tmp[0].list[0].price,
            delete: this.takeawayServices.order_tmp[0].list[0].delete,
            count: this.takeawayServices.order_tmp[0].list[0].count,
            type: this.takeawayServices.order_tmp[0].list[0].type,
            uid_element: this.takeawayServices.order_tmp[0].list[0].uid_element,
            variation: this.takeawayServices.order_tmp[0].list[0].variations,
            waiter: this.globals.waiter,
            waiter_uid: this.globals.waiter_uid,
        };
        //getIndexByTableuid
        await this.takeawayServices.getIndexByTableuid();
        //update tables
        this.takeawayServices.afs.collection('tables').doc(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID).update({
            ticket: {
                amount: this.takeawayServices.table_tmp.ticket.amount,
                payment: this.takeawayServices.table_tmp.ticket.payment,
                payment_type: this.takeawayServices.table_tmp.ticket.payment_type,
                date: this.takeawayServices.table_tmp.ticket.date,
                number: this.takeawayServices.table_tmp.ticket.number,
                waiter: this.takeawayServices.table_tmp.ticket.waiter,
                waiter_uid: this.takeawayServices.table_tmp.ticket.waiter_uid,
                list: this.takeawayServices.table_tmp.ticket.list,
                updated_at: new Date(),
                created_at: this.takeawayServices.table_tmp.ticket.created_at,
                delivery: this.takeawayServices.table_tmp.ticket.delivery,
                order_state: this.globals.ifVarEmpty(this.takeawayServices.table_tmp.ticket.order_state),
                tip: this.takeawayServices.table_tmp.ticket.tip || 0,
            },
            state: 'close'
        }).then(async doc => {
            this.takeawayServices.update_state = false;
            this.takeawayServices.i = '';
            this.takeawayServices.j = '';
            this.takeawayServices.element = '';
            this.takeawayServices.order_tmp = [];
            //getIndexByTableuid
            await this.takeawayServices.getIndexByTableuid();
            //listSelectedTicket
            this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list))
            this.navCtrl.pop();
        });
    }

    openModSelect() {
        this.takeawayServices.element.sections[this.takeawayServices.i].list[this.takeawayServices.j].change = this.takeawayServices.order_tmp[0].list[0].name;
        this.takeawayServices.element.sections[this.takeawayServices.i].list[this.takeawayServices.j].state = 'change';
        this.takeawayServices.element.sections[this.takeawayServices.i].list[this.takeawayServices.j].finish = '';
        this.takeawayServices.element.sections[this.takeawayServices.i].list[this.takeawayServices.j].waiter = this.globals.waiter;
        this.takeawayServices.element.sections[this.takeawayServices.i].list[this.takeawayServices.j].waiter_uid = this.globals.waiter_uid;
        this.takeawayServices.element.sections[this.takeawayServices.i].list[this.takeawayServices.j].variations = this.takeawayServices.order_tmp[0].list[0].variations;

        this.takeawayServices.afs.collection('orders').doc(this.takeawayServices.element.UID).update({
            sections: this.takeawayServices.element.sections,
            updated_at: new Date(),
        }).then(async doc => {
            this.updateInsertTPV(this.takeawayServices.element.sections[this.takeawayServices.i].list[this.takeawayServices.j].name)
        });
        //insert _data analytics WAITER
        let _element = [];
        _element.push(this.takeawayServices.element.sections[this.takeawayServices.i].list[this.takeawayServices.j].name + " > " + this.takeawayServices.order_tmp[0].list[0].name)
        var waiter = {
            'uid': this.globals.restaurant_uid,
            'waiter': this.globals.waiter,
            'elements': _element,
            'date': new Date(),
            'type': "waiter",
            'type_type': "MODIFY",
        };
        this.analyticsServices.sendWaiter(waiter);
    }


}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-select/takeaway-order-select-selected/takeaway-order-select-selected.ts